import React, { useEffect, useState } from 'react';
import { Col, Modal, Row } from "react-bootstrap";
import { word } from "../../word.js";
import { Autocomplete, TextField } from "@mui/material";
import moment from "moment";
import Loader from "../BlueButton/Loader.js";
import { useDispatch, useSelector } from "react-redux";
import BlueButton from "../BlueButton/BlueButton.js";
import Api from "../../Api.js";
import { dayOffAddLocalRequest } from "../../store/actions/dayoff.js";
import qs from "query-string";
import ErrorToast from "../BlueButton/ErrorToast.js";
import SuccessToast from "../BlueButton/SuccessToast.js";
export default function AddTask({ onHide, show }) {
    const [submitted, setSubmitted] = useState(false)
    const [images, setImages] = useState([])
    const companies = useSelector((state) => state.task.companies);

    const [limitData, setLimitData] = useState({
        organization: [],
        taskTemplate: [],
        manager: [],
        stuff: [],
        agents: [],
    });

  
    useEffect(() => {
        (async () => {
            const { data } = await Api.gerAgentTaskList();
            const { data: agents } = await Api.gerAgentList();
            setLimitData(prev => ({ ...prev, taskTemplate: data, organization: companies, agents }))
        })()
    }, [companies])

    const login = useSelector((state) => state.manager.employee);

    const [form, setForm] = useState({
        task_type_id: '', // ID from AgentTaskType
        title: "",
        description: "",
        assigned_to_id: localStorage.getItem('profession') === 'agent' ? login.id : null, // ID of agent
        due_date: "",
        duration: "",
        status:localStorage.getItem('profession') === 'agent' ? "in_porgress": "pending",
        purchase: "",
        client: null,
        company_id: null
    })
    const handleChange = (name, val) => {

        setForm((prevState) => {
            return {
                ...prevState,
                [name]: val,
            };
        });
    }

    //old

    const query = qs.parse(location.search, { arrayFormat: 'comma' });

    const handleAdd = async () => {
        try {
            setSubmitted(true)
            const { data } = await Api.createAgentTask({ ...form, })
            for (const element of images) {
                const fd = new FormData();
                fd.append("task", String(data.id));
                fd.append("file", element);
                await Api.createAgentTaskFile(fd)

            }
            SuccessToast()
            setSubmitted(false)

            onHide()
        } catch (e) {
            ErrorToast()
            setSubmitted(false)

        }
    }
    const handleFileChange = (e) => {
        const picked = Array.from(e.target.files || []);
        setImages((prev) => {
            const seen = new Set(prev.map(f => `${f.name}|${f.size}|${f.lastModified}`));
            const next = [...prev];
            for (const f of picked) {
                const k = `${f.name}|${f.size}|${f.lastModified}`;
                if (!seen.has(k)) next.push(f);
            }
            return next;
        });
        e.target.value = "";
    };

    const deletePhoto = (file) => {
        setImages((prev) => prev.filter((f) => f !== file));
    };
    const keyPress = async (e) => {
        if (e.key === "Enter") {
            await handleAdd()
        }
    };
    return (
        <Modal
            {...{ onHide, show }}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered


        >
            <Modal.Header className='green-top'>
                <Modal.Title id="contained-modal-title-vcenter"
                    className="w-100 d-flex flex-row justify-content-between">
                    <span>Ավելացնել նոր Աշխատանքի առաջարկ</span>
                    <div className="tool-tip-cont">
                        <div className="tool-tip">Փակել</div>
                        <i className="fas fa-times" onClick={onHide} />
                    </div>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className='container'>
                    <Row className="justify-content-center">
                        <Col xs={12} sm={10}>
                            <div
                                className={!form.title && submitted ? "input-validation input-validation-valid" : "input-validation"}>
                                <Autocomplete
                                    loading={limitData.taskTemplate.length <= 0}
                                    loadingText={<div className="auto-complete-loader"><Loader size={15} /></div>}
                                    id="combo-box-demo"
                                    options={limitData.taskTemplate}
                                    onChange={(e, value) => {
                                        console.log(value);

                                        handleChange("task_type_id", value?.id)
                                    }}
                                    getOptionLabel={option => {
                                        return option.name
                                    }}
                                    renderInput={params => (
                                        <TextField
                                            {...params}
                                            label="Ընտրել առաջադրանքի տեսակ"
                                            variant="outlined" fullWidth
                                            onKeyDown={(e) => {
                                                keyPress(e)
                                            }} />
                                    )}
                                />
                            </div>
                            <div
                                className={!form.title && submitted ? "input-validation input-validation-valid" : "input-validation"}>
                                <TextField
                                    name='title'
                                    value={form.title}
                                    onChange={(e) => handleChange('title', e.target.value)}
                                    label="Անվանում"
                                    multiline
                                    variant="outlined"
                                    error={!form.title && submitted}
                                    className={!form.title && submitted ? "validation-outlined-input" : "outlined-helperText"}
                                />
                                {!form.title && submitted &&
                                    <div className="validation valid-center">{word['empty_error']}</div>}
                            </div>
                            <div
                                className={!form.description && submitted ? "input-validation input-validation-valid" : "input-validation"}>
                                <TextField
                                    name='text'
                                    value={form.description}
                                    onChange={(e) => handleChange('description', e.target.value)}
                                    label="Նկարագրություն"
                                    multiline
                                    variant="outlined"
                                    error={!form.description && submitted}
                                    className={!form.description && submitted ? "validation-outlined-input" : "outlined-helperText"}
                                />
                                {!form.description && submitted &&
                                    <div className="validation valid-center">{word['empty_error']}</div>}
                            </div>
                            <div
                                className={!form.title && submitted ? "input-validation input-validation-valid" : "input-validation"}>
                                <Autocomplete
                                    loading={limitData.organization.length <= 0}
                                    loadingText={<div className="auto-complete-loader"><Loader size={15} /></div>}
                                    id="combo-box-demo"
                                    options={limitData.organization}
                                    onChange={(e, value) => {
                                        handleChange("company_id", value.id)
                                    }}
                                    getOptionLabel={option => {
                                        return option.name
                                    }}
                                    renderInput={params => (
                                        <TextField
                                            {...params}
                                            label="Ընտրել Կազմակերպություն"
                                            variant="outlined" fullWidth
                                            onKeyDown={(e) => {
                                                keyPress(e)
                                            }} />
                                    )}
                                />
                            </div>
                            {form.task_type_id === 3 && localStorage.getItem('profession') !== 'agent' && (
                                <div className="input-validation">
                                    <Autocomplete
                                        loading={limitData.agents.length <= 0}
                                        loadingText={<div className="auto-complete-loader"><Loader size={15} /></div>}
                                        id="agent-select"
                                        options={limitData.agents}
                                        onChange={(e, value) => {
                                            handleChange("assigned_to_id", value?.id || null)
                                        }}
                                        getOptionLabel={option => {
                                            return `${option?.user?.first_name || ''} ${option?.user?.last_name || ''}`
                                        }}
                                        renderInput={params => (
                                            <TextField
                                                {...params}
                                                label="Ընտրել Ագենտ"
                                                variant="outlined" 
                                                fullWidth
                                                onKeyDown={(e) => {
                                                    keyPress(e)
                                                }} 
                                            />
                                        )}
                                    />
                                </div>
                            )}
                            <div className='input-validation'>
                                <TextField
                                    // disabled
                                    id="datetime-local"
                                    value={form.due_date}
                                    label="Ժամանակացույց"
                                    type="datetime-local"
                                    onChange={(ev) => handleChange('due_date', ev.target.value)}
                                    variant="outlined"
                                    InputProps={{ inputProps: { min: moment(new Date()).format("YYYY-MM-DDTHH:mm") } }}
                                    sx={{ width: 250 }}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                />
                            </div>
                            {limitData.taskTemplate.find(t => +t.id === +form.task_type_id)?.desc === "advice" ? <div className='input-validation'>
                                <TextField
                                    label="Տևողություն (րոպե)"
                                    type="number"
                                    inputProps={{ min: 0, step: 1 }}
                                    onChange={(e) => {
                                        const mins = Number(e.target.value);
                                        const hh = String(Math.floor(mins / 60)).padStart(2, "0");
                                        const mm = String(mins % 60).padStart(2, "0");
                                        const duration = `${hh}:${mm}:00`;
                                        setForm(prev => ({ ...prev, duration }));
                                    }}
                                />
                            </div> : null}
                            {limitData.taskTemplate.find(t => +t.id === +form.task_type_id)?.desc === "fix" ? <div className='input-validation'>
                                <TextField
                                    label="Գումար"
                                    type="number"
                                    inputProps={{ min: 0, step: 1 }}
                                    onChange={(e) => {
                                        setForm(prev => ({ ...prev, purchase: e.target.value }));
                                    }}
                                />
                            </div> : null}
                            <div className='img-icon-cont'>
                                <div className='img-cont'>
                                    {images.map((item, index) => {
                                        return <div className='img' key={index}>
                                            <span
                                                className={(item.type === "image/jpeg") || (item.type === "image/png") ? 'icon-Photos' : "icon-files-empty"} />
                                            <span className='images-name'>{item.name}</span>
                                            <i className="fas fa-times" onClick={() => deletePhoto(item)} />
                                        </div>
                                    })}
                                </div>
                                <label>
                                    <span className='icon-Attachment' />
                                    <input type="file" multiple className='input-icon'
                                        onChange={(e) => handleFileChange(e)} />
                                </label>

                            </div>
                            <div className='line-blue' />

                            {submitted ? <div className="disable-loader"><Loader size={30} /></div> : null}
                            <div className='button-line'>
                                <BlueButton disabled={submitted}
                                    title={word.create}
                                    buttonStyle={!submitted ? "blue-button" : "blue-button blue-button-disabled"}
                                    onChangeValue={() => submitted?null: handleAdd()}
                                />
                            </div>
                        </Col>
                    </Row>
                </div>
            </Modal.Body>
        </Modal>
    )
}
